import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { default as Header } from "../../Components/Header2/Header2";
import { default as Footer } from "../../Components/Footer/FooterSmall";
import useAPI from "../../Hooks/useAPI";

// export default function ResetPassword() {
//   const navigate = useNavigate();
//   const [searchParams] = useSearchParams();
//   const { confirmEmail } = useAPI();
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");

  // const handleSubmit = async (e: React.FormEvent) => {
  //   e.preventDefault();
  //   setError("");
  //   setSuccess("");


  //   const token = searchParams.get("token");
  //   if (!token) {
  //     setError("Invalid confirmation link");
  //     return;
  //   }

  //   try {
  //     await confirmEmail(token);
  //     setSuccess(
  //       "Your email has been confirmed!"
  //     );
  //     setTimeout(() => {
  //       navigate("/user-login");
  //     }, 3000);
  //   } catch (err) {
  //     setError("Invalid confirmation link");
  //   }
  // };

  // return (
  //   <>
  //     <Header />
  //     <div className="reset-password-container">
  //       <div className="reset-password-card">
  //         <div className="reset-password-header">
  //           <h2 className="reset-password-title">Confirming Email</h2>
  //         </div>

  //         {error && <div className="error-message">{error}</div>}

  //         {success && <div className="success-message">{success}</div>}
  //       </div>
  //     </div>
  //     <Footer />
  //   </>
//   );
// }

const ConfirmEmailPage: React.FC = () =>  {
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { confirmEmail } = useAPI();

  const hasRunRef = useRef(false);

useEffect(() => {
  if (hasRunRef.current) return;
  hasRunRef.current = true;

  const runConfirmation = async () => {
    setError("");
    setSuccess("");

    const token = searchParams.get("token");
    if (!token) {
      setError("Invalid confirmation link");
      return;
    }

    try {
      await confirmEmail(token);
      setSuccess("Your email has been confirmed!");

      setTimeout(() => {
        navigate("/user-login");
      }, 3000);
    } catch {
      setError("Invalid confirmation link");
    }
  };

  runConfirmation();
}, [navigate, confirmEmail, searchParams]);

  return (
    <>
      <Header />
      <div className="reset-password-container">
        <div className="reset-password-card">
          <div className="reset-password-header">
            <h2 className="reset-password-title">Confirming Email</h2>
          </div>

          {error && <div className="error-message">{error}</div>}
          {success && <div className="success-message">{success}</div>}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ConfirmEmailPage;
